import { UserWithSubscriptionRepresentation } from "@shared/dto/UserWithSubscriptionRepresentation";
import Config from "../config";

const baseURL = Config.api.root;

export async function createSubscription(
  paymentId: string,
  email: string | null
): Promise<UserWithSubscriptionRepresentation> {
  const result = await fetch(`${baseURL}/api/user/subscription`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email: email,
      paymentId: paymentId
    })
  });
  return result.json();
}

export async function cancelSubscription(): Promise<UserWithSubscriptionRepresentation> {
  const result = await fetch(`${baseURL}/api/user/subscription`, {
    method: "DELETE",
    credentials: "include"
  });
  return result.json();
}

export async function getUserSubscription(): Promise<UserWithSubscriptionRepresentation> {
  const result = await fetch(`${baseURL}/api/user/subscription`, {
    credentials: "include"
  });
  return result.json();
}
